import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { LinkContainer } from "react-router-bootstrap";
import { Container, Navbar, Nav, Image, NavDropdown } from "react-bootstrap";
import { logout } from "../actions/userActions";

export default function Header() {
  const dispatch = useDispatch();

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const logoutHandler = () => {
    dispatch(logout());
  };
  return (
    <header>
      <Navbar
        className="navbar-dark navbar-custom"
        expand="lg"
        collapseOnSelect
      >
        <Container>
          <LinkContainer to="/">
            <Navbar.Brand>
              <Image
                src="/logo192.png"
                width="60"
                className="d-inline-block align-top"
                alt="Wheels And Motors"
              />
            </Navbar.Brand>
          </LinkContainer>
          <LinkContainer to="/">
            <Navbar.Brand>Wheels And Motors</Navbar.Brand>
          </LinkContainer>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ml-auto">
              <LinkContainer to="/about">
                <Nav.Link>
                  <i className="fas fa-info"></i> How It Works
                </Nav.Link>
              </LinkContainer>
              <LinkContainer to="/findmanual">
                <Nav.Link>
                  <i className="fas fa-wrench"></i> Vehicle Manuals
                </Nav.Link>
              </LinkContainer>
              <LinkContainer to="/updatemanual">
                <Nav.Link>
                  <i className="fas fa-plus"></i> Add Manual
                </Nav.Link>
              </LinkContainer>
              {userInfo ? (
                <NavDropdown title={userInfo.name} id="username">
                  <LinkContainer to="/profile">
                    <NavDropdown.Item>Profile</NavDropdown.Item>
                  </LinkContainer>
                  {userInfo.isAdmin && (
                    <>
                      <LinkContainer to="/admin/contactlist">
                        <NavDropdown.Item>Contacts</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer to="/admin/userlist">
                        <NavDropdown.Item>Admin Users</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer to="/admin/vehiclelist">
                        <NavDropdown.Item>Admin Vehicles</NavDropdown.Item>
                      </LinkContainer>
                    </>
                  )}
                  <NavDropdown.Item onClick={logoutHandler}>
                    Log Out
                  </NavDropdown.Item>
                </NavDropdown>
              ) : (
                <LinkContainer to="/login">
                  <Nav.Link>
                    <i className="fas fa-user"></i> Sign In
                  </Nav.Link>
                </LinkContainer>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
}
